
const YoungBelievers = () => {
  return (
    <div className="bg-[#fff] w-full flex flex-col">
      <div
        className="relative w-full bg-cover bg-center h-[550px] flex items-center justify-center"
        style={{
          backgroundImage: "url('./images/investment.png')",
        }}
      >
        <div className="absolute inset-0 bg-black/60" />
        <div className="relative text-center px-6 md:px-12 lg:px-20 max-w-4xl">
          <h1 className="text-white text-3xl md:text-5xl font-bold leading-tight mb-4">
            How Investing in Young Believers Ensures a Strong Church for Generations
          </h1>
          <p className="text-gray-200 text-lg md:text-xl">
            Nurturing children and youth today secures the Church’s faith, leadership, and impact for tomorrow.
          </p>
        </div>
      </div>

      <section className="body--container w-full px-4 py-10 md:px-12 lg:px-24 xl:px-32">
        <div className="mx-auto max-w-4xl text-gray-800 leading-relaxed">
          <p className="mb-6">
            The Church’s strength, growth, and impact are built on the faith and commitment of the next generation. 
            Investing in young believers is both a spiritual and strategic act, ensuring the Church thrives for generations to come.
          </p>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              1. The Next Generation Shapes the Future
            </h2>
            <p>
              Children and youth are active participants today and leaders tomorrow. Grounding them in biblical principles and Scripture 
              develops responsible, compassionate, and committed believers who will strengthen and sustain the Church’s mission.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              2. Building Strong Faith Foundations
            </h2>
            <p>
              Programs like Sunday School, youth groups, and mentorship teach biblical literacy, spiritual disciplines, and Christian values 
              such as honesty, kindness, and service. A strong foundation equips young believers to face life with confidence and faith.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              3. Encouraging Active Participation and Leadership
            </h2>
            <p>
              Providing opportunities to lead prayers, discussions, participate in service projects, or assist in Sunday School cultivates 
              confidence, leadership skills, and a sense of ownership in young believers.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              4. Strengthening Families and Communities
            </h2>
            <p>
              Children who grow in faith influence their families through prayer, shared values, and active participation in church and 
              community service. Spiritually strong families form the backbone of thriving congregations.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              5. Fostering Lifelong Commitment to the Church
            </h2>
            <p>
              Consistent engagement through Sunday School, youth programs, and mentorship instills a sense of belonging, deepens personal faith, 
              and encourages service and leadership, ensuring a vibrant Church across generations.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              6. Leaving a Lasting Legacy
            </h2>
            <p>
              Every lesson, mentorship moment, and encouragement planted in young believers builds spiritual resilience, nurtures communities 
              guided by Christian values, and ensures a Church that continues to grow in faith, compassion, and impact.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              Conclusion: The Power of Intentional Investment
            </h2>
            <p>
              Nurturing and equipping young believers today shapes the Church of tomorrow. Through spiritual education, mentorship, leadership opportunities, 
              and a loving community, churches cultivate faithful, committed, and capable leaders, securing a legacy of strength, service, and spiritual impact for generations.
            </p>
          </div>
        </div>
      </section>

      <section className="mb-12">
        <div className="max-w-4xl mx-auto flex flex-col lg:flex-row justify-between items-center gap-6">
          <div className="flex flex-wrap gap-2">
            <p className="bg-gray-200 text-gray-600 px-3 py-1 rounded-md">Youth Ministry</p>
            <p className="bg-gray-200 text-gray-600 px-3 py-1 rounded-md">Sunday School</p>
            <p className="bg-gray-200 text-gray-600 px-3 py-1 rounded-md">Church Leadership</p>
            <p className="bg-gray-200 text-gray-600 px-3 py-1 rounded-md">Faith Development</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default YoungBelievers;